var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4875 0H9.8625V8.25H8.4875V0ZM6.425 0.472656V1.97656C5.19323 2.49219 4.19063 3.32292 3.41719 4.46875C2.6724 5.61458 2.3 6.875 2.3 8.25C2.3 10.1406 2.97318 11.7591 4.31953 13.1055C5.66589 14.4518 7.28438 15.125 9.175 15.125C11.0656 15.125 12.6841 14.4518 14.0305 13.1055C15.3768 11.7591 16.05 10.1406 16.05 8.25C16.05 6.875 15.6633 5.61458 14.8898 4.46875C14.1451 3.32292 13.1568 2.49219 11.925 1.97656V0.472656C13.5578 1.04557 14.8755 2.04818 15.8781 3.48047C16.9094 4.88411 17.425 6.47396 17.425 8.25C17.425 10.513 16.6086 12.4609 14.9758 14.0938C13.3716 15.6979 11.438 16.5 9.175 16.5C6.91198 16.5 4.96406 15.6979 3.33125 14.0938C1.72708 12.4609 0.925 10.513 0.925 8.25C0.925 6.47396 1.4263 4.88411 2.42891 3.48047C3.46016 2.04818 4.79219 1.04557 6.425 0.472656Z",
    fill: "#5D6C71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.df7bbc95545c1a093d91a5b19467cd20.svg";
export { ForwardRef as ReactComponent };